import React from 'react';
import './WeddingPhotographyHeader.css';

const WeddingPhotographyHeader = ({ content = {} }) => (
  <section
    className="wedding-photography"
    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${content.heroImage || '/wedding-header.jpg'})` }}
  >
    <div className="wedding-photography__overlay"></div>

    <div className="wedding-photography__content">
      <h1>{content.title || 'Wedding Photography'}</h1>
      <div className="wedding-photography__underline"></div>
    </div>
  </section>
);

export default WeddingPhotographyHeader;

